import { render, staticRenderFns } from "./ManufacturingLogbook.vue?vue&type=template&id=138ae398&scoped=true"
import script from "./ManufacturingLogbook.vue?vue&type=script&lang=js"
export * from "./ManufacturingLogbook.vue?vue&type=script&lang=js"
import style0 from "./ManufacturingLogbook.vue?vue&type=style&index=0&id=138ae398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ae398",
  null
  
)

export default component.exports